import React from 'react'
import PageHeader from './page-header'

export default () => (
  <div>
    <PageHeader title={"Logged Out"}/>
    <div className="container">
      <p>You have been successfully logged out.</p>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/app/components/logged-out.js